// client/src/components/gemv2/gemV2Api.js

import { consumeQuota } from '../../quotaManager';
import { auth } from '../../firebaseConfig';

export function buildQuery(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === null || v === undefined) return;
    const s = String(v).trim();
    if (!s) return;
    usp.set(k, s);
  });
  const qs = usp.toString();
  return qs ? `?${qs}` : "";
}

export async function apiGetJson(path, quotaType = 'searches') {
  // Consume 1 quota unit before making the request
  const quota = await consumeQuota(quotaType, 1);
  if (!quota.ok) {
    throw new Error(quota.reason || 'Quota exceeded. Please upgrade your plan or purchase an add-on.');
  }

  const token = auth.currentUser ? await auth.currentUser.getIdToken() : null;
  const res = await fetch(path, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(txt || `Request failed: ${res.status}`);
  }
  return await res.json();
}

export function clamp(n, lo, hi) {
  const x = Number.isFinite(n) ? n : lo;
  return Math.max(lo, Math.min(hi, x));
}

export function fmtDate(v) {
  if (!v) return "";
  try {
    const d = new Date(v);
    if (isNaN(d)) return String(v);
    return d.toLocaleString("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return String(v);
  }
}

// Safe “split” for seller labels like:
// "ABC INDUSTRIES under PMA" OR "XYZ LTD (MII)"
export function splitSellerLabel(raw) {
  const s = raw == null ? "" : String(raw).trim();
  if (!s) return { name: "", tag: "" };

  // Pattern A: "... under PMA"
  const mUnder = s.match(/^(.*?)(?:\s+under\s+)([A-Za-z0-9 &/\-_.]{2,})$/i);
  if (mUnder) {
    const name = (mUnder[1] || "").trim();
    const tag = (mUnder[2] || "").trim();
    // Only accept if name is not empty and tag is short-ish (avoid chopping real names)
    if (name && tag && tag.length <= 30) return { name, tag };
  }

  // Pattern B: "... (MII)" or "... (PMA)"
  const mParen = s.match(/^(.*?)(?:\s*\(([^)]+)\)\s*)$/);
  if (mParen) {
    const name = (mParen[1] || "").trim();
    const tag = (mParen[2] || "").trim();
    if (name && tag && tag.length <= 30) return { name, tag };
  }

  return { name: s, tag: "" };
}
